export enum ConversationType {
  CUSTOMER = 0,
  INFO = 1,
  AGENT = 2,
  CHANNEL = 3,
}
